<template>
  <vxe-modal v-model="visible" :loading="loading" title="business.label.lotDetail" type="confirm" width="50%" @cancel="cancel" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="data" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.itemNo')">
            <vxe-input v-model="data.item.no" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.itemName')">
            <vxe-input v-model="data.item.name" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-item :label="$t('business.label.lotNo')">
            <vxe-input v-model="data.no" disabled style="width: 100%"/>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-item :label="$t('business.label.productionDate')">
            <vxe-input v-model="data.productionDate" disabled style="width: 100%"/>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-item :label="$t('business.label.validUntil')">
            <vxe-input v-model="data.validUntil" disabled style="width: 100%"/>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-item :label="$t('business.label.printProductionDate')">
            <vxe-input v-model="data.printProductionDate" style="width: 100%"/>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-item :label="$t('business.label.printValidUntil')">
            <vxe-input v-model="data.printValidUntil" style="width: 100%"/>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-item :label="$t('business.label.manufacturer')">
            <vxe-input v-model="data.manufacturer" disabled style="width: 100%"/>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-item :label="$t('business.label.producingArea')">
            <vxe-input v-model="data.producingArea" disabled style="width: 100%"/>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-item :label="$t('business.label.approvalNo')">
            <vxe-input v-model="data.approvalNo" disabled style="width: 100%"/>
          </a-form-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.licenseNo')">
            <vxe-input v-model="data.license.licenseNo" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.permissionNo')">
            <vxe-input v-model="data.permission.permissionNo" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.practiceNo')">
            <vxe-input v-model="data.practice.practiceNo" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.qualityStandard')">
            <vxe-input v-model="data.quality.qualityStandard" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import { findOne, save } from '@/api/Api'
import { Lot } from '@/api/dto/common/Lot'

export default {
  name: 'LotEditor',
  data() {
    return {
      visible: false,
      loading: false,
      data: new Lot(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 }
    }
  },
  methods: {
    add(item) {
      this.visible = true
      this.data = new Lot()
      this.data.item = item
    },
    edit(id, copy) {
      this.visible = true
      this.loading = true
      findOne('lotFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.data = new Lot(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const data = this.data.toJSONObject()
      save('lotPersister', data).then(res => {
        if (res.success) {
          this.data = new Lot(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.cancel()
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>